import { render } from "./PostCommentComponent.vue?vue&type=template&id=33c282bc&scoped=true&ts=true"
import script from "./PostCommentComponent.vue?vue&type=script&lang=ts"
export * from "./PostCommentComponent.vue?vue&type=script&lang=ts"

import "./PostCommentComponent.vue?vue&type=style&index=0&id=33c282bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c282bc"]])

export default __exports__